interface IAnswerMessageContainerProps {
  children: React.ReactNode;
}

function AnswerMessageContainer(props: IAnswerMessageContainerProps) {
  return (
    <div className="answer-message-container w-[calc(100%-20px)] sm:w-4/5 text-[0.8rem] self-start relative bg-slate-200 text-black/90 ml-5 mb-3 p-4 rounded-lg response-container">
      {props.children}
    </div>
  );
}

export default AnswerMessageContainer;
